<template>
    <div class="form-group">
        <label class="col-md-2">Current Signature</label>
        <div class="col-md-10">
            <div v-if="isLoading">
                <label>Loading...</label>
            </div>
            <div v-if="!currentSignature && !isLoading">
                <label>No signature uploaded</label>
            </div>
            <div v-if="currentSignature">
                <img :src="currentSignature">
            </div>
            <div v-if="currentSignature">
                <button class="btn btn-secondary col-md-1" v-on:click="deleteSignature">Delete</button>
            </div>
        </div>
        <hr style="border:solid 1px #cccccc;" />
        <div class="form-group">
            <label class="col-md-2">Upload New Signature</label>
            <div class="col-md-10">
                <form v-on:submit.prevent class="form" id="documentForm" data-vv-scope="mediaFile">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group" v-bind:class="{ 'has-error': errors.has('mediaFile.newFile') }">
                                <input name="newFile" ref="newFile" class="file" type="file" v-validate="'required'">
                                <div><span v-show="errors.has('mediaFile.newFile')" class="has-error">File is required</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-3"></div>
                        <div class="col-md-8">
                            <div v-show="serverErrorList.length > 0">
                                <span class="has-error">Validation issues must be corrected prior to submit</span>
                                <ul class="has-error">
                                    <li v-for="serverError in serverErrorList" :key="serverError">{{ serverError }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <button class="btn btn-primary col-md-1" v-on:click="saveSignature">Upload</button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import mediaService from '@/services/mediaService'
import loggingService from '@/services/util/loggingService'
import { mapState } from 'vuex'

export default {
    name: 'undertakingDocuments',
    data: function () {
        return {
            isDebug: false,
            isLoading: true,
            serverErrorList: [],
            currentSignature: null,
            currentSignatureDto: null,
            mediaTypeId: mediaService.mediaType.UserSignature,
            filename: ''
        }
    },
    computed: {
        // get current user info
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        userId: function () {
            return this.shpoUserDto.userId
        }
    },
    mounted () {
        this.loadData()
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'User Signature', message)
        },
        loadSignature () {
            this.log('looking for signature, userId: ' + this.userId)
            var handle = this
            return mediaService.list(this.$http, this.mediaTypeId, null, this.userId).then(result => {
                if (result.data.length > 0) {
                    var signature = result.data[0]
                    handle.currentSignatureDto = signature

                    mediaService.get(handle.$http, signature.mediaId, signature.mediaTypeId, signature.mediaSubtypeId, signature.parentId).then(function (response) {
                        handle.currentSignature = 'data:' + response.headers['content-type'] + ';base64,' + btoa(
                            new Uint8Array(response.data)
                            .reduce((data, byte) => data + String.fromCharCode(byte), ''))
                    })
                } else {
                    handle.currentSignatureDto = null
                    handle.currentSignature = null
                }
                return result
            })
        },
        loadData () {
            this.loadSignature().then(result => {
                this.isLoading = false
            })
        },
        saveSignature () {
            this.$validator.validateAll('mediaFile').then(result => {
                this.log('Validating and submitting file')
                if (result) {
                    this.isLoading = true
                    var file = this.$refs['newFile'].files[0]
                    this.log(`Saving signature, filename: ${file.name}`)
                    mediaService.saveUserSignature(this.$http, this.userId, file).then(result => {
                        this.resetFileUploadForm()
                        this.loadData()
                        this.errors.clear()
                    })
                } else {
                    this.log('Submit File - Invalid Form')
                }
            })
        },
        resetFileUploadForm () {
            this.$refs['newFile'].value = null
        },
        deleteSignature () {
            if (this.currentSignatureDto && confirm('Are you sure you want to delete this signature?')) {
                mediaService.removeByMediaId(this.$http, this.currentSignatureDto.mediaId).then(result => {
                    this.loadData()
                })
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// UserSignature.vue?58ad374b